import BaseClient from '../base/baseClient';
import endpoints from '../../features/endPoints/ecommEndpoints';

import Globals from '../../constants/appConstants';
import { formatDateMMDDYYYY , getDateTimeZoneHandled  } from '../../utils/dateUtil';

const paymentsHistoryClient = async (customerNumber) => {
  const { post: postClient } = BaseClient();
  const requestBody = {
    'CustomerNumber': customerNumber
  };
  
  try {
    const response = await postClient(process.env.REACT_APP_ECOMM_URL + endpoints.paymentsHistory(), requestBody, {}, true);
    if (response.error) {
      return mapError(response);
    }
    return mapResponse(response);
  } catch (error) {
    return mapError(error);
  }
};

//map response to object needed by React view
const mapResponse = (response) => {
  const paymentsGroupedByYear = {};

  // Check if response and response.data exist and have the expected structure
  if (!response || !response.data || !response.data.payments) {
    return {
      years: [],
      payments: [],
      invoices: [],
      paymentsGroupedByYear,
    };
  }

  response.data['payments'].map((payment) => {
    let date = getDateTimeZoneHandled(payment.date);
    let year = date.getFullYear();
    let type = payment.subType;
    let ref = payment.referenceNumber.replace(/\*/g, '');
    let formattedDate = formatDateMMDDYYYY(date);
    if (payment.cashType === 'ACH' || payment.subType === 'CHK') {
      type = 'Checking';
      ref = 'Check # ' + ref;
    } else if (payment.cashType === 'CCD') {
      switch (payment.subType) {
      case 'AMX':
        type = 'American Express';
        break;
      case 'DCV':
        type = 'Discover';
        break;
      case 'MCD':
        type = 'Mastercard';
        break;
      case 'VIS':
        type = 'Visa';
        break;
      }
      ref = 'Account ending in ' + ref;
    }

    let paymentObject = {
      ...payment,
      date: getDateTimeZoneHandled(payment.date),
      formattedDate,
      type,
      ref,
      symbol: Globals.currencySymbol,
      amountBase: Math.floor(payment.amount),
      amountDec: payment.amount.toFixed(2).split('.')[1]
    };
    if (!paymentsGroupedByYear[year]) {
      paymentsGroupedByYear[year] = [];
    }
    paymentsGroupedByYear[year].push(paymentObject);
  });

  return {
    years: response.data['payment years'] || [],
    payments: response.data['payments'] || [],
    invoices: response.data['invoices'] || [],
    paymentsGroupedByYear,
  };
};

//map error to object needed by React view
const mapError = (error) => {
  return error;
};

export default paymentsHistoryClient;
